// Jackyee: colour swatches on product cards switch the card image and links to that colour.
(function () {
  if (window.jyCardSwatches) return;
  window.jyCardSwatches = true;

  function pick(swatch) {
    var card = swatch.closest('.card-wrapper');
    if (!card) return;
    var img = card.querySelector('.card__media img');
    if (img) {
      img.srcset = swatch.dataset.srcset;
      img.src = swatch.dataset.src;
    }
    card.querySelectorAll('a.full-unstyled-link').forEach(function (a) {
      a.href = swatch.dataset.url;
    });
    card.querySelectorAll('[data-jy-card-swatch]').forEach(function (s) {
      s.classList.toggle('is-active', s === swatch);
    });
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-jy-card-swatch]');
    if (!swatch) return;
    event.preventDefault();
    pick(swatch);
  });

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-jy-card-swatch]');
    if (swatch && window.matchMedia('(hover: hover)').matches) pick(swatch);
  });
})();